export const newsIcons = [
  {
    category: "delays",
    icon: "local_shipping",
  },
  {
    category: "compliance",
    icon: "gavel",
  },
  {
    category: "environmental",
    icon: "thermostat",
  },
  {
    category: "commodities",
    icon: "agriculture",
  },
  {
    category: "esg",
    icon: "groups",
  },
  {
    category: "supplier market",
    icon: "factory",
  },
];
